export type VMenuTheme = 'primary' | 'secondary';

const getTextColor = (theme?: VMenuTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'tw-text-white';
    default:
      return 'tw-text-primary-900';
  }
};

const getSubmenuheaderTextColor = (theme?: VMenuTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'tw-text-white/50';
    default:
      return 'tw-text-primary-900';
  }
};

const getBackgroundColor = (theme?: VMenuTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'tw-bg-primary-800';
    case 'secondary':
      return 'tw-bg-grey-100';
    default:
      return 'tw-bg-white';
  }
};

const getActiveBackgroundColor = (theme?: VMenuTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'tw-bg-primary-600';
    case 'secondary':
      return 'tw-bg-grey-200';
    default:
      return 'tw-bg-grey-100';
  }
};

const getHoverColor = (theme?: VMenuTheme | undefined) => {
  switch (theme) {
    case 'primary':
      return 'hover:tw-bg-white/25';
    case 'secondary':
      return 'hover:tw-bg-grey-200';
    default:
      return 'hover:tw-bg-grey-100';
  }
};

export const getStylesObj = (theme?: VMenuTheme | undefined) => ({
  textColor: getTextColor(theme),
  submenuLabelTextColor: getSubmenuheaderTextColor(theme),
  bgColor: getBackgroundColor(theme),
  activeBgColor: getActiveBackgroundColor(theme),
  hoverColor: getHoverColor(theme),
});
